import React, { useState, useRef } from 'react';
import { loginUrl2 } from '../../../utils/staticPageUrls';
import { Layout, Collapse, Button, Select } from 'antd';
// import {
//   HeaderLanding,
//   SubHeaderLanding,
//   Footer,
// } from 'components/layout/components';
import { ReactComponent as Minus } from '../../../assets/icons/minus.svg';
import { ReactComponent as Plus } from '../../../assets/icons/plus.svg';
import bot_img from '../../../assets/icons/Final_Chatobot_RGB.SVG';
import SubmitLanding from '../../../assets/icons/SubmitLanding.svg';
import { TableCell } from '@mui/material';
import HeaderLanding from './staticsHeader';
import Footer from './staticFooter';
import { useNavigate } from 'react-router-dom';
import isEmpty from 'lodash/isEmpty';
import οdigosAthina from 'assets/documents/ΦΕΚ_Αθηνά.pdf';
import odigosFoivos from 'assets/documents/ΦΕΚ_Φοίβος.pdf';
import syxnesErotisis from 'assets/documents/Συχνές_Ερωτήσεις_Φοίβος_Αθήνα.pdf';
import apovlitaYD from 'assets/documents/ΥΔ ΑΕΚΚ.docx';

const { Content } = Layout;
const { Panel } = Collapse;
// const { Option } = Select;

const StaticPage1 = () => {
  const data = [
    {
      key: '1',
      column1: 'A',
      column2: 'Κτίριο (εφόσον τοποθετηθεί BEP στο κτίριο)',
      column3: '200 €',
    },
    {
      key: '2',
      column1: 'A',
      column2: 'Όροφος (εφόσον τοποθετηθεί FB στον όροφο)',
      column3: '140 €',
    },
    {
      key: '3',
      column1: 'Β',
      column2: 'Κτίριο',
      column3: '60 €',
    },
    {
      key: '4',
      column1: 'Γ',
      column2: 'Κτίριο',
      column3: '60 €',
    },
    {
      key: '5',
      column1: 'Δ',
      column2: 'Κτίριο',
      column3: '60 €',
    },
    {
      key: '6',
      column1: 'Ε',
      column2: 'Κτίριο',
      column3: '60 €',
    },
  ];

  const documents = [
    {
      category: 'Κοινή Υπουργική Απόφαση',
      documents: [
        // {
        // 	label: '2η Τροποποίηση της Κοινής Υπουργικής Απόφασης',
        //   date: '16/12/2022',
        // 	link: SmartReadinessPdf
        // },
        // {
        //   label: 'Κοινή Υπουργική Απόφαση',
        //   date: '23/02/2023',
        //   link: SmartReadinessKYA,
        // },
        // {
        //   label: 'Τροποποίηση ΚΥΑ_SR',
        //   date: '20/09/2023',
        //   link: SmartReadinessKYARe,
        // },
        // {
        //   label: 'ΚΥΑ Εσωτερικών Εγκαταστάσεων',
        //   date: '13/12/2023',
        //   link: SmartReadinessKYARe2,
        // },
      ],
    },
    {
      category: 'Οδηγός Προγράμματος',
      documents: [
        {
          label: 'Οδηγός Προγράμματος - ΑΘΗΝΑ',
          date: '11/02/2025',
          link: οdigosAthina,
        },
        {
          label: 'Οδηγός Προγράμματος - ΦΟΙΒΟΣ',
          date: '11/02/2025',
          link: odigosFoivos,
        },
      ],
    },
    {
      category: 'Διάφορα',
      documents: [
        {
          label: 'Συχνές_Ερωτήσεις_Φοίβος_Αθήνα',
          //date: '10/06/2022',
          link: syxnesErotisis,
        },
        {
          label: 'ΥΔ ΔΙΑΘΕΣΗΣ ΑΠΟΒΛΗΤΩΝ Α.Ε.Κ.Κ. / Α.Η.Η.Ε',
          //date: '10/06/2022',
          link: apovlitaYD,
        },
      ],
    },
  ];

  const [generalInfo, setGeneralInfo] = useState(true);
  const [docsTab, setDocsTab] = useState(false);
  const [activeKey, setActiveKey] = useState();
  const [showBot, setShowBot] = useState(false);
  const [minimizeBot, setMinimizeBot] = useState(false);

  const handleMinimize = () => {
    setShowBot(false);
    setMinimizeBot(true);
  };

  const handleOpen = () => {
    setShowBot(true);
    setMinimizeBot(false);
  };

  return (
    <Layout id="landing-page">
      <HeaderLanding
        setShowBot={setShowBot}
        showBot={showBot}
        className="header-landing"
      />
      <Content>
        <div className="sub-header-image">
          <div className="hero-space">
            <div className="hero-space-body">
              <div className="left-hero-space">
                <div className="hero-text-space">
                  <span className="left-hero-text">
                    Η υποβολή αιτήσεων στα Προγράμματα "Φοίβος" και "Αθηνά"
                    ολοκληρωθηκε στις 15 Μαΐου 2025.
                  </span>
                </div>
                <div className="title-display-space">
                  {/* <TitleDisplay className="title-icon-wrapper" /> */}
                  <div id="header-texts">
                    <div className="header-text-1">
                      <span>
                        Πρόγραμμα χρηματοδότησης για την Ενεργειακή Αναβάθμιση
                        Νηπιαγωγείων και Δημοτικών σχολείων «Αθηνά» και
                        Δημοτικών Παιδικών Σταθμών «Φοίβος»
                      </span>
                    </div>
                    {/* <div className="header-text-2">
                        <span>
                        Φωτοβολταϊκά στις Επιχειρήσεις                     
                        </span>
                      </div> */}
                  </div>
                  <div id="hero-texts">
                    <div className="title-text-1">
                      {/* <FirstIcon /> */}
                      <div className="title-text">
                        <span>
                          Επιχορήγηση με στόχο την ενεργειακή αναβάθμιση των
                          Δημόσιων κτιρίων που φιλοξενούν νηπιαγωγεία, δημοτικά
                          σχολεία και παιδικούς σταθμούς.
                        </span>
                      </div>
                    </div>
                    {/* <div className="title-text-1">
                      
                      <span className="title-text">
                      Επιχορηγούνται επιχειρήσεις, ανεξαρτήτως μεγέθους και κλάδου οικονομικής δραστηριότητας.
                      </span>
                    </div> */}
                    <div className="title-text-1">
                      <span className="title-text">
                        Στόχος είναι η βελτίωση της ενεργειακής απόδοσης των
                        κτιρίων.
                        <br />
                        <br />
                        <span
                          style={{
                            color: 'red',
                            display: 'block',
                            wordWrap: 'break-word',
                          }}
                        >
                          Η προθεσμία υλοποίησης των Προγραμμάτων, παρατείνεται{' '}
                          <strong>έως την 30η Απριλίου 2026.</strong>
                        </span>
                        <br />
                        Δείτε πληροφορίες{' '}
                        <a
                          href="https://ypen.gov.gr/to-ypourgeio-perivallontos-kai-energeias-anakoinonei-parataseis-se-energeiaka-programmata-entagmena-sto-tameio-anakampsis-kai-anthektikotitas/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          εδώ
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="right-hero-space">
                <PhoneIcon className="phone-icon-wrapper" />
              </div> */}
            </div>
            <div className="hero-footer">
              {
                <div id="hero-text">
                  Το Πρόγραμμα «Φοίβος» χρηματοδοτείται από πόρους του Ταμείου
                  Ανάκαμψης και Ανθεκτικότητας στο πλαίσιο της Δράσης του ΤΑΑ –
                  16994 με τίτλο «Ενεργειακή απόδοση και προώθηση των ΑΠΕ για
                  αυτοκατανάλωση» <br />
                  Το Πρόγραμμα «Αθηνά» χρηματοδοτείται από πόρους του Ταμείου
                  Ανάκαμψης και Ανθεκτικότητας στο πλαίσιο της Δράσης του ΤΑΑ –
                  16994 με τίτλο «Ενεργειακή απόδοση και προώθηση των ΑΠΕ για
                  αυτοκατανάλωση»
                </div>
              }
            </div>
          </div>
        </div>
        <div className="sub-header-container">
          {/* <div className="sub-header-wifi">
            <Wifi />
          </div> */}
          <div className="sub-header mb-5">
            <h3 className="sub-header-top-text">1 ΒΗΜΑ ΓΙΑ ΝΑ ΚΑΝΕΤΕ</h3>{' '}
            <h1 className="sub-header-btm-text">AITHΣH</h1>
          </div>
          {/* New deadline extension banner */}
          {/* <div className="deadline-extension-banner">
            <p className="deadline-extension-text">
              <strong>Το τηλεφωνικό κέντρο του Helpdesk του Προγράμματος δεν θα λειτουργεί από 11 έως και 15 Αυγούστου</strong>
            </p>
          </div> */}
        </div>

        <div
          id="iframe"
          className="bot"
          style={{ display: showBot && !minimizeBot ? 'block' : 'none' }}
        >
          <div className="bot-minus">
            <a onClick={() => handleMinimize()}>
              <Minus
                style={{ marginLeft: '0.625rem', marginBottom: '0.188rem' }}
              />
            </a>
          </div>
          <iframe
            className="bot-iframe"
            src="https://smartreadiness.streamlit.app/?embed=true"
          ></iframe>
          <div className="bot-white"></div>
        </div>

        <div
          id="iframe"
          className="bot-minimize"
          style={{ display: !showBot && minimizeBot ? 'block' : 'none' }}
        >
          <div>
            <div>
              <a onClick={() => handleOpen()}>
                <img src={bot_img} alt="bot_img" width={100} height={100} />
              </a>
            </div>
          </div>
        </div>

        <div className="badges-container">
          <div className="badges">
            <div
              className="badges-icon"
              style={{
                marginTop: '1rem',
              }}
            >
              1
            </div>
            <div className="badges-content">
              <h2 className="badges-title">Υποβολή Αίτησης</h2>
              <img
                src={SubmitLanding}
                alt="Submit Icon"
                style={{
                  width: '4.46375rem',
                  height: '4.761875rem',
                  marginRight: '0.5rem',
                }}
              />
              <div className="badges-text-container">
                <p
                  className="badges-text"
                  style={{ color: '#46616B', fontSize: '1.375rem' }}
                >
                  Για να υποβάλετε αίτηση, συνδεθείτε με τους κωδικούς Taxisnet
                  (username & password) του Δήμου.
                </p>
                <p
                  className="badges-text"
                  style={{ color: '#46616B', fontSize: '0.875rem' }}
                >
                  Με τον τρόπο αυτό, βεβαιώνετε ότι εκπροσωπείτε νομίμως τον
                  συγκεκριμένο φορέα για την:
                </p>

                <ul
                  className="badges-list"
                  style={{ color: '#46616B', fontSize: '0.875rem' }}
                >
                  <li>υποβολή της Αίτησης Συμμετοχής στο Πρόγραμμα και την</li>
                  <li>
                    μετέπειτα επικοινωνία και ανταλλαγή πληροφοριών στο πλαίσιο
                    του Προγράμματος.
                  </li>
                </ul>
                {/* <div className="badges-note">
                  <img
                    src={featuredIcon}
                    alt="Alert Icon"
                    style={{
                      width: '2rem',
                      height: '2rem',
                      borderRadius: '1rem',
                    }}
                  />
                  <span style={{ color: '#59299E' }}>Προσοχή</span>
                </div> */}
                {/* <p
                  className="badges-text"
                  style={{ color: '#46616B', fontSize: '0.875rem' }}
                >
                  Αν η επιχείρηση είναι διακριτό νομικό πρόσωπο, θα πρέπει να
                  χρησιμοποιήσετε τους κωδικούς της επιχείρησης, και όχι τους
                  προσωπικούς σας κωδικούς. Προσωπικούς κωδικούς θα
                  χρησιμοποιήσετε μόνο στις περιπτώσεις επιτηδευματιών ή
                  ατομικών επιχειρήσεων όπου το Α.Φ.Μ. επιχείρησης και Φυσικού
                  Προσώπου ταυτίζονται.
                </p> */}
                {process.env.REACT_APP_LANDING_LOGIN_TO_PLATFORM === 'true' && (
                  <a
                    href={loginUrl2}
                    className="badges-button"
                    style={{
                      marginTop: '1rem',
                      borderRadius: '23px',
                    }}
                  >
                    Είσοδος στην πλατφόρμα →
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="main-content">
          <div className="collapse-header">
            <Button
              className={generalInfo ? 'active-page' : ''}
              id="staticButtons"
              onClick={() => {
                setGeneralInfo(true);
                setDocsTab(false);
              }}
            >
              <span
                style={{
                  fontFamily: 'Roboto',
                  fontSize: '26px',
                  fontWeight: '300',
                  lineHeight: '33.45px',
                  letterSpacing: '0.04em',
                  textAlign: 'left',
                  color: '#049DD7',
                }}
              >
                ΓΕΝΙΚΕΣ ΠΛΗΡΟΦΟΡΙΕΣ
              </span>
            </Button>
            <Button
              className={docsTab ? 'active-page' : ''}
              id="staticButtons"
              onClick={() => {
                // setGeneralInfo(false);
                setDocsTab(!docsTab);
              }}
            >
              <span
                style={{
                  fontFamily: 'Roboto',
                  fontSize: '26px',
                  fontWeight: '300',
                  lineHeight: '33.45px',
                  letterSpacing: '0.04em',
                  textAlign: 'left',
                  color: '#049DD7',
                }}
              >
                ΕΓΓΡΑΦΑ ΠΡΟΓΡΑΜΜΑΤΟΣ
              </span>
            </Button>
          </div>
          {docsTab &&
            !isEmpty(documents) &&
            !documents?.every(category => isEmpty(category?.documents)) && (
              <div className="documents-content">
                <h1 className="documents-header">Έγγραφα Προγράμματος</h1>
                <div className="documents-items">
                  {documents?.map(item => (
                    <div className="docs">
                      <h2 className="documents-category">{item.category}</h2>
                      <div className="documents-info">
                        {item.documents?.map(item => (
                          <>
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={item.link}
                            >
                              {item.label}
                            </a>
                            <p>{item.date}</p>
                          </>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          {generalInfo && (
            <>
              <Collapse
                key="1"
                className="main-content__collapse"
                expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '1' ? setActiveKey('') : setActiveKey('1')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text style={{ color: 'white' }}>
                      ΣΚΟΠΟΣ ΚΑΙ ΑΝΤΙΚΕΙΜΕΝΟ
                    </text>
                  }
                  key="1"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>
                      ΣΚΟΠΟΣ ΚΑΙ ΑΝΤΙΚΕΙΜΕΝΟ{' '}
                    </b>
                    <br></br>
                    <br></br>
                    <p>
                      Σκοπός του Προγράμματος είναι η βελτίωση της ενεργειακής
                      απόδοσης του κτιριακού αποθέματος, κυριότητας ή χρήσης,
                      υπό όρους που ορίζονται στην πρόσκληση υποβολής αιτήσεων,
                      των Δικαιούχων του άρθρου 2, με παρεμβάσεις περιορισμού
                      της ενεργειακής ζήτησης που συνδέεται με την χρήση του
                      κτιρίου, η οποία περιλαμβάνει, μεταξύ άλλων, την ενέργεια
                      που χρησιμοποιείται για τα τεχνικά συστήματα όπως για
                      θέρμανση, ψύξη, καθώς και ευπαθή σημεία του κτιρίου τα
                      οποία επιτρέπουν τις θερμικές απώλειες (όπως κουφώματα,
                      οροφές, κλπ) , διασφαλίζοντας τα βέλτιστα επίπεδα θερμικής
                      άνεσης.
                    </p>
                    <p>
                      Στόχοι του Προγράμματος είναι η επιτάχυνση της υλοποίησης
                      έργων τοπικού χαρακτήρα και σημαντικού αντίκτυπου στην
                      ενεργειακή απόδοση στον δημόσιο τομέα, παράλληλα με την
                      επίτευξη, κατ’ ελάχιστον, 30% εξοικονόμησης ετήσιας
                      πρωτογενούς ενέργειας που απαιτείται για τις ανάγκες των
                      τεχνικών συστημάτων που εξυπηρετούν το κτίριο, καθώς και η
                      διασφάλιση ότι δεν βλάπτονται σημαντικά οι περιβαλλοντικοί
                      στόχοι, υιοθετώντας τις συγκεκριμένες απαιτήσεις του
                      Προγράμματος.
                    </p>
                  </div>
                </Panel>
              </Collapse>

              <Collapse
                key="2"
                className="main-content__collapse"
                expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '2' ? setActiveKey('') : setActiveKey('2')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text style={{ color: 'white' }}>
                      ΔΙΚΑΙΟΥΧΟΙ ΤΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ
                    </text>
                  }
                  key="2"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>
                      ΔΙΚΑΙΟΥΧΟΙ ΤΟΥ ΠΡΟΓΡΑΜΜΑΤΟΣ
                    </b>
                    <br></br>
                    <br></br>
                    <p>
                      1. Δικαιούχοι του Προγράμματος «Φοίβος» είναι οι δημοτικοί
                      παιδικοί σταθμοί που στεγάζονται σε ιδιόκτητα (ή χρήσης)
                      δημοτικά κτίρια τα οποία έχουν κατασκευαστεί προ του 2000
                      και δεν έχουν έκτοτε αναβαθμιστεί ενεργειακά μέσω της
                      υλοποίησης ολοκληρωμένων έργων.
                    </p>
                    <p>
                      2. Δικαιούχοι του προγράμματος «Αθηνά» είναι οι ΟΤΑ Α’
                      βαθμού, για παρεμβάσεις σε νηπιαγωγεία και δημοτικά
                      σχολεία που στεγάζονται σε ιδιόκτητα ή μισθωμένα δημοτικά
                      κτίρια, τα οποία έχουν κατασκευαστεί προ του 2000 και δεν
                      έχουν αναβαθμιστεί, έκτοτε, ενεργειακά.
                    </p>
                  </div>
                </Panel>
              </Collapse>

              <Collapse
                key="3"
                className="main-content__collapse"
                expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '3' ? setActiveKey('') : setActiveKey('3')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text style={{ color: 'white' }}>ΠΟΣΟ ΕΝΙΣΧΥΣΗΣ</text>
                  }
                  key="3"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>ΠΟΣΟ ΕΝΙΣΧΥΣΗΣ</b>
                    <br></br>
                    <br></br>
                    <p>
                      Για το πρόγραμμα "Φοίβος" ως ανώτατος επιλέξιμος
                      Προϋπολογισμός κάθε υποβαλλόμενης Αίτησης Ένταξης ορίζεται
                      το ποσό των 75.000,00 ευρώ (€), συμπεριλαμβανομένου του
                      αναλογούντος ΦΠΑ.
                    </p>
                    <p>
                      Για το πρόγραμμα "Αθηνά" ως ανώτατος επιλέξιμος
                      Προϋπολογισμός κάθε υποβαλλόμενης Αίτησης Ένταξης ορίζεται
                      το ποσό των 80.000,00 ευρώ (€) για τα Νηπιαγωγεία,
                      συμπεριλαμβανομένου του αναλογούντος ΦΠΑ και 300.000,00
                      ευρώ (€) για τα Δημοτικά, συμπεριλαμβανομένου του
                      αναλογούντος ΦΠΑ.
                    </p>
                  </div>
                </Panel>
              </Collapse>

              <Collapse
                key="4"
                className="main-content__collapse"
                expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '4' ? setActiveKey('') : setActiveKey('4')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text style={{ color: 'white' }}>ΕΠΙΛΕΞΙΜΕΣ ΔΑΠΑΝΕΣ</text>
                  }
                  key="4"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>ΕΠΙΛΕΞΙΜΕΣ ΔΑΠΑΝΕΣ</b>
                    <br></br>
                    <br></br>
                    <p>
                      &emsp;&emsp;- Εφαρμογή συστήματος θερμομόνωσης σε αδιαφανή
                      στοιχεία του κελύφους
                    </p>
                    <p>
                      &emsp;&emsp;- Αντικατάσταση διαφανών στοιχείων
                      (κουφωμάτων) του κελύφους.
                    </p>
                    <p>
                      &emsp;&emsp;- Αναβάθμιση συστήματος θέρμανσης (ή και
                      ψύξης) χώρων.
                    </p>
                    <p>
                      &emsp;&emsp;- Δαπάνες για συμβουλευτικές και μελετητικές
                      υπηρεσίες.
                    </p>
                  </div>
                </Panel>
              </Collapse>

              <Collapse
                key="5"
                className="main-content__collapse"
                expandIcon={({ isActive }) => (isActive ? <Minus /> : <Plus />)}
                expandIconPosition={'right'}
                onChange={e =>
                  activeKey === '5' ? setActiveKey('') : setActiveKey('5')
                }
                activeKey={activeKey}
              >
                <Panel
                  header={
                    <text style={{ color: 'white' }}>
                      ΔΙΑΔΙΚΑΣΙΑ ΥΠΟΒΟΛΗΣ ΑΙΤΗΣΗΣ ΣΤΟ ΠΡΟΓΡΑΜΜΑ
                    </text>
                  }
                  key="5"
                >
                  <div>
                    <b style={{ fontSize: '1.5rem' }}>
                      ΔΙΑΔΙΚΑΣΙΑ ΥΠΟΒΟΛΗΣ ΑΙΤΗΣΗΣ ΣΤΟ ΠΡΟΓΡΑΜΜΑ
                    </b>
                    <br></br>
                    <br></br>
                    <p>
                      &emsp;- Οι υποψήφιοι Δικαιούχοι που επιθυμούν να
                      συμμετέχουν στο Πρόγραμμα, υποβάλλουν αίτηση
                      χρηματοδότησης μέσω της ηλεκτρονικής πλατφόρμας του
                      Προγράμματος.
                    </p>
                    <p>
                      &emsp;- Για την υποβολή της αίτησης απαιτείται υποχρεωτικά
                      η προηγούμενη αυθεντικοποίηση του αιτούντος με τη χρήση
                      των κωδικών – διαπιστευτηρίων της Γενικής Γραμματείας
                      Πληροφοριακών Συστημάτων Δημόσιας Διοίκησης του Υπουργείου
                      Ψηφιακής Διακυβέρνησης (taxisnet), σύμφωνα με το άρθρο 24
                      του ν.4727/2020 (Α’ 184), όπως ισχύει.
                    </p>
                    <p>
                      &emsp;- Μεταβαίνει στο ασφαλές περιβάλλον της Γενικής
                      Γραμματείας Πληροφοριακών Συστημάτων Δημόσιας Διοίκησης
                      (ΓΓΠΣΔΔ) για την καταχώρηση των εταιρικών διαπιστευτηρίων
                      στην υπηρεσία αυθεντικοποίησης χρηστών.
                    </p>
                    <p>
                      &emsp;- Μετά την αυθεντικοποίησή του, ο αιτών αρχικά
                      συμπληρώνει σε ηλεκτρονικές φόρμες διάφορα βασικά
                      στοιχεία, επιλέγει τη βαθμίδα σχολείου για την οποία
                      υποβάλλει Αίτηση Χρηματοδότησης και ταυτόχρονα υποβάλλει
                      τα απαραίτητα δικαιολογητικά.
                    </p>
                    <p>
                      &emsp;- Ο αιτών σε ξεχωριστή καρτέλα συμπληρώνει τα
                      στοιχεία του κτιρίου και το κόστος παρέμβασης.
                    </p>
                    <p>
                      &emsp;- Τέλος, ο αιτών αποδέχεται ηλεκτρονικά τους όρους
                      και τις προϋποθέσεις του προγράμματος και προχωρεί στην
                      υποβολή της αίτησης.
                    </p>
                  </div>
                </Panel>
              </Collapse>
            </>
          )}
        </div>
      </Content>
      <div className="landing-page-footer-smart">
        <Footer />
      </div>
    </Layout>
  );
};

export default StaticPage1;
